import { actions } from './actions'
import { mutations } from './mutations'

export const eyewearProtection = {
  namespaced: true,
  state: {
    availabilityResponse: [],
    isAtLeastOneCheckboxChecked: false,
    isFetchingForAvailability: false,
  },
  getters: {
    availabilityResponse: (state) => state.availabilityResponse,
    isAtLeastOneCheckboxChecked: (state) => state.isAtLeastOneCheckboxChecked,
    isFetchingForAvailability: (state) => state.isFetchingForAvailability,
  },
  mutations,
  actions,
}
